import React from "react";
import { Box, List} from "@mui/material";
import ProfileIcon from "@mui/icons-material/Person";
import HomeIcon from "@mui/icons-material/Home";
import CreateIcon from "@mui/icons-material/Create";
import ProgramIcon from "@mui/icons-material/School";
import ManageProgramsIcon from "@mui/icons-material/SettingsApplications";
import AssignmentIcon from "@mui/icons-material/Assignment";
import NavigateListItem from "../components/NavigateListItem";
import { Folder } from "@mui/icons-material";

import "./homePage.css?v=1.0";
import Welcome from "../components/Welcome";

const Sidebar = ({ userProfile }) => {
  return (
    userProfile ? (
    <Box className="sidebar-left">
      <List>
        <NavigateListItem to="/" icon={<HomeIcon />} text="Accueil" />
        {userProfile.type === "university" && (
          <NavigateListItem to={`/profile/${userProfile._id}`} icon={<ProfileIcon />} text="Profil" />
        )}
        
        {userProfile.type === "student" && (
          <NavigateListItem to={`/mes-documents/${userProfile._id}`} icon={<Folder />} text="Mes Documents" />
        )}

        {userProfile.type === "student" && (
          <NavigateListItem to={`/candidatures/${userProfile._id}`} icon={<AssignmentIcon />} text="Mes Candidatures" />
        )}

        {userProfile.canAddPublication && (
          <NavigateListItem to="/publication" icon={<CreateIcon />} text="Créer une Publication" />
        )}

        {userProfile.canAddProgram && (
          <NavigateListItem to="/program" icon={<ProgramIcon />} text="Ajouter un Programme" />
        )}

        {userProfile.canManageCandidature && (
          <NavigateListItem to="/gestion-candidatures" icon={<AssignmentIcon />} text="Gestion des Candidatures" />
        )}

        {userProfile.type === "admin" && (
          <NavigateListItem to="/news" icon={<AssignmentIcon />} text="Ajouter une Actualité" />
        )}

        {userProfile.type === "admin" && (
          <NavigateListItem to="/gestion-actualites" icon={<AssignmentIcon />} text="Gestion des Actualités" />
        )}

        {userProfile.type === "admin" && (
                  <NavigateListItem to="/gestion-utilisateurs" icon={<ManageProgramsIcon />} text="Gestion des Utilisateurs" />
        )}


      </List>
    </Box>
    ):(
      <Box className="sidebar-left">
        <Welcome/>
      </Box>
    )
  );
};

export default Sidebar;
